import { useState, useEffect } from 'react'
import DashboardMultiSelect from '../../../GlobalComponents/_misc/DashboardMultiSelect'
import {
    fetchProductCodeData,
    VendorProductCodes,
    Vendors,
} from '../../../features/inventory/inventoryAPI'

interface ProductCodeMultiSelectProps {
    selectedVendors: Vendors
    selectedValues: VendorProductCodes
    onSelectedValuesChanged(selectedValues: VendorProductCodes): void
}

const VendorMultiSelect = (props: ProductCodeMultiSelectProps) => {
    const [data, setData] = useState<VendorProductCodes>([])
    const [selectedValues, setSelectedValues] = useState<VendorProductCodes>([])
    const [selectedVendors, setSelectedVendors] = useState<Vendors>([])

    useEffect(() => {
        async function getProductCodeData() {
            // Only keep product codes that exist in selected Vendors list
            const newSelectedValues = selectedValues.filter((pc) =>
                props.selectedVendors.some((vend) => vend.VendorID === pc.VendorID)
            )
            // if (newSelectedValues.length !== selectedValues.length) onChange(newSelectedValues)
            setSelectedValues(newSelectedValues)

            let pcData: VendorProductCodes = []
            if (props.selectedVendors.length > 0)
                pcData = await fetchProductCodeData(props.selectedVendors)
            if (pcData) {
                let curVID = ''

                for (let i = 0; i < pcData.length; i++) {
                    if (pcData[i].VendorID !== '' && pcData[i].VendorID !== curVID) {
                        pcData.splice(i, 0, {
                            VendorID: pcData[i].VendorID,
                            ProductCode: 'All',
                            VendorIDProductCode: `${pcData[i].VendorID} - All`,
                            ProductCodeName: `${pcData[i].VendorID} - All`,
                            VendorIDProductCodeCount: pcData.filter(
                                (pc) =>
                                    pc.ProductCode !== '' &&
                                    pc.ProductCode !== 'All' &&
                                    pc.VendorID === pcData[i].VendorID
                            ).length,
                        })
                        curVID = pcData[i].VendorID
                    }
                }
                setData(pcData)
            }

            // If vendor is newly-added, select all of its product codes - should be new to data
            const newVendors = props.selectedVendors.filter(
                (sv) => !selectedVendors.some((v) => v.VendorID === sv.VendorID)
            )
            if (newVendors.length > 0) {
                let newSelectedValues = [...selectedValues]
                for (let i = 0; i < newVendors.length; i++) {
                    if (newVendors[i].VendorID !== '') {
                        newSelectedValues.push({
                            VendorID: newVendors[i].VendorID,
                            ProductCode: 'All',
                            VendorIDProductCode: `${newVendors[i].VendorID} - All`,
                            ProductCodeName: `${newVendors[i].VendorID} - All`,
                            VendorIDProductCodeCount: pcData.filter(
                                (pc) =>
                                    pc.ProductCode !== '' &&
                                    pc.ProductCode !== 'All' &&
                                    pc.VendorID === newVendors[i].VendorID
                            ).length,
                        })
                    }
                }
                setSelectedValues(newSelectedValues)
            }
            setSelectedVendors(props.selectedVendors)
        }
        getProductCodeData()
    }, [props.selectedVendors])

    useEffect(() => {
        let newSelectedValues = selectedValues

        for (let i = 0; i < selectedValues.length; i++) {
            if (selectedValues[i].ProductCode === 'All') {
                // remove any product codes for current vendor id
                newSelectedValues = newSelectedValues.filter(
                    (pc) => pc.VendorID !== selectedValues[i].VendorID
                )

                // now add all possible product codes for vendor id
                newSelectedValues = [
                    ...newSelectedValues,
                    ...data.filter((pc) => pc.VendorID === selectedValues[i].VendorID),
                ]

                // we don't actually want the "PC - All" items in our data
                newSelectedValues = newSelectedValues.filter((pc) => {
                    return pc.ProductCode !== 'All'
                })
            }
        }

        props.onSelectedValuesChanged(newSelectedValues)
    }, [selectedValues])

    return (
        <DashboardMultiSelect
            data={data}
            keyField="VendorIDProductCode"
            textField="ProductCodeName"
            selectedValues={selectedValues}
            onSelectedValuesChanged={(values: VendorProductCodes) => {
                setSelectedValues(values)
            }}
        />
    )
}

export default VendorMultiSelect
